import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token from localStorage as fallback (cookies primary)
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("session_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
